import { useTranslation } from "react-i18next"
import { formatDate } from "../../../admin_extension_tokens/utils/date"
// import { formatDate } from "../../utils/date"

const AggregateTable = ({ groupBy, rows, onRowClick }) => {
  const { t } = useTranslation()

  return (
    <div className="bg-white rounded-2xl border border-[#E7EAEF] divide-y divide-[#E7EAEF] overflow-hidden">
      <div className="hidden md:flex items-center gap-4 px-4 py-2.5 text-[11px] font-semibold text-[#9AA5B4] uppercase tracking-wide">
        <div className="flex-1">
          {groupBy === "company"
            ? t("admin_saved_tours.table.company")
            : t("admin_saved_tours.table.user")}
        </div>
        {groupBy === "user" && <div className="w-40">{t("admin_saved_tours.table.company")}</div>}
        {groupBy === "company" && <div className="w-24 text-right">{t("admin_saved_tours.table.users")}</div>}
        <div className="w-24 text-right">{t("admin_saved_tours.table.sessions")}</div>
        <div className="w-24 text-right">{t("admin_saved_tours.table.tours")}</div>
        <div className="w-36 text-right">{t("admin_saved_tours.table.last_activity")}</div>
      </div>

      {rows.map((row) => {
        const key = groupBy === "company" ? row.company_id : row.user_id
        const title =
          groupBy === "company" ? row.company_name : row.user?.name || row.user?.email

        return (
          <div
            key={key}
            onClick={() => onRowClick(row)}
            className="flex flex-col md:flex-row md:items-center gap-1.5 md:gap-4 px-4 py-3 hover:bg-[#FAFBFC] cursor-pointer"
          >
            <div className="flex-1 min-w-0">
              <div className="text-sm font-medium text-[#1F2937] truncate">
                {title || t("admin_saved_tours.table.unknown")}
              </div>
              {groupBy === "user" && row.user?.email && (
                <div className="text-xs text-[#9AA5B4] truncate">{row.user.email}</div>
              )}
            </div>

            {groupBy === "user" && (
              <div className="md:w-40 text-xs text-[#9AA5B4] truncate">{row.company_name}</div>
            )}

            {groupBy === "company" && (
              <div className="md:w-24 text-sm text-[#1F2937] md:text-right">{row.users_count}</div>
            )}

            <div className="md:w-24 text-sm text-[#1F2937] md:text-right">{row.sessions_count}</div>
            <div className="md:w-24 text-sm text-[#1F2937] md:text-right">{row.tours_count}</div>
            <div className="md:w-36 text-xs text-[#9AA5B4] md:text-right">
              {formatDate(row.last_activity_at)}
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default AggregateTable
